import { ContractLanguageView } from "./ContractLanguageView";

const OTC_CONTRACT_LANGUAGE_ID = "fc4878db-1b1a-4b74-addb-ee5304fbb2a8";

export function ContractsLanguageOtcDashboard() {
  return (
    <ContractLanguageView
      knowledgeItemId={OTC_CONTRACT_LANGUAGE_ID}
      title="OTC Contract Language"
    />
  );
}
